import { atom } from "recoil";

let balanceCreditLimitRequestToken = 0;

export const createBalanceCreditLimitRequestToken = () => {
	balanceCreditLimitRequestToken += 1;
	return balanceCreditLimitRequestToken;
};

export const createBalanceCreditLimitState = (context = {}) => ({
	loading: false,
	loaded: false,
	error: "",
	enabled: false,
	operationLimitMinor: 0,
	totalLimitMinor: 0,
	usedMinor: 0,
	remainingMinor: 0,
	project: typeof context.project === "undefined" ? null : context.project,
	brand: typeof context.brand === "undefined" ? null : context.brand,
	login: context.login || "",
	requestToken: context.requestToken || 0,
});

export const getBalanceCreditLimitContext = (playerPage, user) => {
	const brand = typeof user?.brand?.id === "undefined" ? null : user.brand.id;
	const playerProject = playerPage?.data?.project;

	return {
		project: typeof playerProject === "undefined" || playerProject === null || playerProject === 0 ? brand : playerProject,
		brand,
		login: user?.login || "",
	};
};

export const isSameBalanceCreditLimitContext = (left, right) =>
	Boolean(left && right) &&
	left.project !== null &&
	right.project !== null &&
	left.brand !== null &&
	right.brand !== null &&
	String(left.project) === String(right.project) &&
	String(left.brand) === String(right.brand) &&
	left.login === right.login;

export const normalizeBalanceCreditLimitState = (state) => {
	const quotaFields = ["operationLimitMinor", "totalLimitMinor", "usedMinor", "remainingMinor"];

	if (
		!state ||
		typeof state !== "object" ||
		Array.isArray(state) ||
		typeof state.enabled !== "boolean" ||
		!quotaFields.every((field) => Number.isSafeInteger(state[field]))
	) {
		throw new Error("Invalid balance credit limit response");
	}

	if (state.enabled === false) {
		if (!quotaFields.every((field) => state[field] === 0)) {
			throw new Error("Invalid balance credit limit response");
		}
	} else if (
		state.operationLimitMinor <= 0 ||
		state.totalLimitMinor <= 0 ||
		state.usedMinor < 0 ||
		state.remainingMinor < 0 ||
		state.operationLimitMinor > state.totalLimitMinor ||
		state.usedMinor > state.totalLimitMinor ||
		state.remainingMinor !== state.totalLimitMinor - state.usedMinor
	) {
		throw new Error("Invalid balance credit limit response");
	}

	return {
		enabled: state.enabled,
		operationLimitMinor: state.operationLimitMinor,
		totalLimitMinor: state.totalLimitMinor,
		usedMinor: state.usedMinor,
		remainingMinor: state.remainingMinor,
	};
};

export const playerModalStore = atom({
	key: "playerModalStore",
	default: {
		show: false,
		type: false,
		title: false,
		description: false,
		units: false,
		description2: false,
		units2: false,
		item: false,
		value: "",
		value2: "",
		promoReasonSelected: null,
		promoGameSelected: null,
		promoReasonOptions: [],
		promoReasonsLoading: false,
		promoReasonsError: "",
		promoReasonSubmitting: false,
		balanceCreditLimit: createBalanceCreditLimitState(),
		vipWager: "",
		vipCap: "",
		// Freespins fields
		providerSelected: null,
		gameSelected: null,
		availableGames: [],
		spinsCount: "",
		betAmount: "",
		bonusName: "",
		expiresAt: "",
		vipReasonSelected: null,
		vipReasonOptions: [],
		vipRulesLoading: false,
		vipRulesError: "",
		vipCheckLoading: false,
		vipCheckStatus: "idle",
		vipCheckLogId: null,
		vipCheckError: "",
		vipCheckResponse: null,
		vipGrantLoading: false,
		currentOption: {
			reason: [
				{label: "FrodDeposit", value: "FrodDeposit"},
				{label: "Description_in_the_panel", value: "Description_in_the_panel"},
				{label: "8.5", value: "8.5"},
				{label: "8.5.1", value: "8.5.1"},
				{label: "8.5.2", value: "8.5.2"},
				{label: "8.5.3", value: "8.5.3"},
				{label: "8.4.2", value: "8.4.2"},
				{label: "8.3_Before_dep", value: "8.3_Before_dep"},
				{label: "8.3.1_Before_dep", value: "8.3.1_Before_dep"},
				{label: "3.1.2.22_Before_dep", value: "3.1.2.22_Before_dep"},
				{label: "3.1.2.4_Before_dep", value: "3.1.2.4_Before_dep"}
			]
		}
	},
});
